import React, { ComponentType, useEffect } from 'react';
import { LocalizationConfig, LocalizationProvider } from '@scuf/localization';
import { translations } from './translations';

export interface IWithLocalizationProps extends Object {
  languageCode?: string;
}

export const withLocalization = <P extends Object>(
  WrappedComponent: ComponentType<P>
): React.FC<P & IWithLocalizationProps> => {
  return (props: P & IWithLocalizationProps) => {
    return (
      <LocalizationConfig languageCode={props.languageCode || 'en-US'}>
        <LocalizationProvider
          translations={translations}
          fallbackLanguages={['en-US']}
        >
          <WrappedComponent {...props} />
        </LocalizationProvider>
      </LocalizationConfig>
    );
  };
};
